export default "__VITE_ASSET__ASQ619dT__"